module.exports = __webpack_public_path__ + "img/step7.ad0d3843.png";